import * as Autolinker from 'autolinker';
import { MediaType, MediaDocument } from '../../media-document.model';

export class ContentDocumentInstagramAdapter {
    static toContentDocument(document: any): MediaDocument {
        let contentDocument = new MediaDocument(document);
        let author = document.authors && document.authors[0] ? document.authors[0] : {};

        contentDocument.documentId = document.documentId;
        contentDocument.isHosted = document.isHosted;
        contentDocument.authors = document.authors.map((author: any) => {
            const copy = Object.assign({}, author);
            copy.name = copy.handle;
            return copy;
        });
        contentDocument.body = Autolinker.link(document.matchSentence || document.tagContextMatchSentence || document.body);
        contentDocument.date = document.date;
        contentDocument.dupDocs = [];
        contentDocument.dupDocsCount = document.dupDocsCount;
        contentDocument.dupDocsIdsRemaining = document.remainingDupDocsIds;
        contentDocument.keywords = document.keywords || document.tagContextKeywords;
        contentDocument.mediaType = MediaType.Instagram;
        contentDocument.mediaTypeIcon = document.mediaTypeIcon || contentDocument.mediaType;
        contentDocument.mediaImageUrl = (document.images && document.images[0]) ? document.images[0].link : '';
        contentDocument.provider = document.provider;
        contentDocument.sentiment = document.isSentimentModified ? document.originalSentiment : document.sentiment;
        contentDocument.sentimentOverride = document.isSentimentModified ? document.sentiment : '';
        contentDocument.sourceAvatarRounded = true;
        contentDocument.sourceAvatarImgUrl = author.avatarUrl;
        contentDocument.sourceAvatarLinkUrl = author.url;
        contentDocument.sourceCountryCode = document.country || document.countryCode;
        contentDocument.sourceName = (author.authorInfo && author.authorInfo.rawName) ? author.authorInfo.rawName : author.name || author.handle || 'Unknown';
        contentDocument.sourceNameUrl = author.url;
        contentDocument.tags = document.tags;
        contentDocument.language = document.language;

        // TODO: not sure if we need this, might be same as sourceUrl
        contentDocument.url = document.redirectUrl || document.url || document.sourceUrl;

        // TODO: not sure if we should bake in support for these but putting them in for now
        contentDocument.reachCount = document.reach;
        contentDocument.potentialReach = document.potentialReach;

        return contentDocument;
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/adapter/adapters/content-document-instagram.adapter.ts